
<div class="user-edit-dialog">
  <div *ngIf="isLoading" class="user-edit-loading">
    <mat-spinner diameter="38"></mat-spinner>
  </div>

  <div *ngIf="!isLoading" class="user-edit-content">
    <div class="user-edit-title-area">
      <div class="container user-edit-title-container">
        <div class="user-edit-title">
          <div>
            <span class="user-edit-eyebrow">ADMINVY</span>
            <h2 *ngIf="!user?.IsCompany" class="sam-page-heading">{{user.FirstName}} {{user?.LastName}}</h2>
            <h2 *ngIf="user?.IsCompany" class="sam-page-heading">{{user.CompanyName}}</h2>
            <div class="user-edit-title-meta">
              <span><mat-icon>calendar_today</mat-icon> Medlem sedan: {{user.Created | swedishDate: 'yyyy-MM-dd'}}</span>
              <span *ngIf="user.CreatedFromSpar"><mat-icon>sync</mat-icon> SPAR uppdaterad: {{user.LastSparUpdate | swedishDate: 'yyyy-MM-dd'}}</span>
            </div>
          </div>
          <button *ngIf="isDialog"
                  mat-icon-button
                  type="button"
                  class="user-edit-close"
                  aria-label="Stäng"
                  (click)="dialogRef?.close()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="user-edit-scroll-content">
      <div class="container">
        <div class="backgroundcolor">

  <div *ngIf="isAdmin" class="row">
    <div class="col-12">
      <mat-card class="card-margin input-card admin-overview-card">

        <h3>Översikt</h3>

        <div class="row overview-dates">
          <div class="col-6">
            <span class="field-label">SPAR-data hämtat från</span>
            <div class="readonly-value" *ngIf="user.CreatedFromSpar">{{user.LastSparUpdate | swedishDate:'yyyy-MM-dd'}}</div>
            <div class="readonly-value" *ngIf="!user.CreatedFromSpar">Ej hämtat</div>
          </div>
          <div class="col-6">
            <span class="field-label">Medlem sedan</span>
            <div class="readonly-value">{{user.Created | swedishDate: 'yyyy-MM-dd'}}</div>
          </div>
        </div>

      <mat-form-field style="width: 100%" floatLabel="always">
        <mat-label>Info om medlem som bara admin ser</mat-label>
        <textarea matInput rows="2" [ngModel]="user.AdminInfo" (ngModelChange)="user.AdminInfo = $event" id="admininfo" name="admininfp"></textarea>
      </mat-form-field>
        <div class="row admin-checkbox-row">
          <div class="col-lg-6">
            <div style="width: 100%" floatLabel="always">
              <mat-checkbox matInput [ngModel]="user.HasCustomServiceFee" (change)="changeValue($event)" id="hascustomservicefee" name="hascustomservicefee">Har avtalad serviceavgift</mat-checkbox>
            </div>
          </div>
          <div class="col-lg-6">
            <mat-checkbox matInput [ngModel]="user.Suspended" (change)="changeValueSuspended($event)" id="suspended" name="suspended">Medlemmen är spärrad</mat-checkbox>
          </div>
          <div class="col-lg-6 service-fee-field" *ngIf="user.HasCustomServiceFee">
            <mat-form-field style="width: 100%" floatLabel="always">
              <mat-label>Avtalad serviceavgift, procent</mat-label>
              <input type="number" matInput [ngModel]="CustomServiceFee" (ngModelChange)="CustomServiceFee = $event" id="servicefee" name="servicefee" #servicefee="ngModel">
            </mat-form-field>
          </div>
        </div>
      </mat-card>

      <mat-card class="card-margin input-card notifications-card">
        <h3>Notifikationer</h3>
        <span class="section-description">Valda mailnotifikationer</span>
        <mat-form-field style="width: 100%" floatLabel="always">
          <mat-select [(ngModel)]="selectedNotificationTypes" (ngModelChange)="notificationSettingsChange($event)" [ngModelOptions]="{standalone: true}" multiple>
            <mat-option *ngFor="let s of user.NotificationSettings" [value]="s.Type.Id">
              {{ s.Type.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card>
    </div>
  </div>
  <!-- ********************* -->
  <!-- Private user settings -->
  <!-- ********************* -->

  <div *ngIf="!user.IsCompany" class="row">
    <div class="col-12 ">
      <form name="form" (ngSubmit)="onSubmit()" #f="ngForm">
        <mat-card class="card-margin input-card">
          <h3>Personuppgifter</h3>
          <div class="row" style="margin-bottom: 15px;">

            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Anställningsnummer</mat-label>
                <input matInput [ngModel]="user.EmploymentNumber" (ngModelChange)="user.EmploymentNumber = $event" id="employmentnumber" name="employmentnumber">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Medlemsnummer</mat-label>
                <input matInput readonly [ngModel]="user.MemberNumber" (ngModelChange)="user.MemberNumber = $event" id="membernumber" name="membernumber">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Förnamn</mat-label>
                <input matInput [ngModel]="user.FirstName" (ngModelChange)="user.FirstName = $event" id="firstname" name="firstname">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Efternamn</mat-label>
                <input matInput [ngModel]="user.LastName" (ngModelChange)="user.LastName = $event" id="lastname" name="lastname">
              </mat-form-field>
            </div>
            <div class="col-sm-12">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Valt visningsnamn</mat-label>
                <input matInput [ngModel]="user.DisplayName" (ngModelChange)="user.DisplayName = $event" id="displayname" name="displayname">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Telefon</mat-label>
                <input matInput [ngModel]="user.Phone" (ngModelChange)="user.Phone = $event" id="telephone" name="telephone">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>E-post</mat-label>
                <input matInput [ngModel]="user.Email" (ngModelChange)="user.Email = $event" id="email" name="email">
              </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Personnummer</mat-label>
                <input matInput [ngModel]="user.PersonalNumber" (ngModelChange)="user.PersonalNumber = $event" id="PersonalNumber" name="PersonalNumber">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-checkbox matInput [ngModel]="user.HasCoordinationNumber" ngModel (change)="changeCoordinationNumberValue($event)" id="hascono" name="hascono">Medlemmen har samordningsnummer</mat-checkbox>
            </div>
            <div *ngIf="user.HasCoordinationNumber" class="col-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>ÅÅÅÅMMDD</mat-label>
                <input matInput [ngModel]="user?.BirthYear" (ngModelChange)="user.BirthYear = $event" ngModel pattern="[0-9]{8}" maxlength="8" id="BirthYear" name="BirthYear">
                <mat-hint>Födelsedatum (8 siffror)</mat-hint>
              </mat-form-field>
            </div>
            
          </div>
        </mat-card>

        <mat-card class="card-margin input-card">
          <div class="row" style="margin-bottom: 15px;">
            <!-- Adress -->
            <div class="col-12"><h4>Folkbokföringsadress</h4></div>

            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Folkbokföringsadress</mat-label>
                <input matInput [readonly]="user.CreatedFromSpar" [attr.aria-disabled]="user.CreatedFromSpar ? 'true' : null" [ngModel]="user.Address" (ngModelChange)="user.Address = $event" id="address" name="address">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>c/o</mat-label>
                <input matInput [readonly]="user.CreatedFromSpar" [attr.aria-disabled]="user.CreatedFromSpar ? 'true' : null" [ngModel]="user.Co" (ngModelChange)="user.Co = $event" id="coaddress" name="coaddress">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Postnummer</mat-label>
                <input matInput [readonly]="user.CreatedFromSpar" [attr.aria-disabled]="user.CreatedFromSpar ? 'true' : null" [ngModel]="user.Zip" (ngModelChange)="user.Zip = $event" id="zip" name="zip">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Ort</mat-label>
                <input matInput [readonly]="user.CreatedFromSpar" [attr.aria-disabled]="user.CreatedFromSpar ? 'true' : null" [ngModel]="user.City" (ngModelChange)="user.City = $event" id="city" name="city">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field floatLabel="always">
                <mat-label>Kommun</mat-label>
                <ng-container *ngIf="!user.CreatedFromSpar; else municipalityReadonlyField">
                  <mat-select name="companies" [(ngModel)]="user.Municipality.Id" (ngModelChange)="municipalityChange($event)">
                    <mat-option *ngFor="let c of municipalities" [value]="c.Id">
                      {{ c.Name }}
                    </mat-option>
                  </mat-select>
                </ng-container>
                <ng-template #municipalityReadonlyField>
                  <input matInput readonly aria-disabled="true" [value]="user?.Municipality?.Name || ''">
                </ng-template>
              </mat-form-field>
              <span style="margin-left:25px;">Skatt: {{user.Municipality.Tax * 100 | number:'1.2-2'}} %</span>
            </div>
          </div>
        </mat-card>

        <mat-card class="card-margin input-card">
          <div class="row" style="margin-bottom: 15px;">
            <!-- Utdelningsadress -->
            <div class="col-12"><h4>Utdelningsadress</h4></div>

            <div class="col-12">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Utdelningsadress</mat-label>
                <input matInput [ngModel]="user.DeliveryAddress" (ngModelChange)="user.DeliveryAddress = $event" id="levaddress" name="levaddress">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Postnummer</mat-label>
                <input matInput [ngModel]="user.DeliveryZip" (ngModelChange)="user.DeliveryZip = $event" id="levzip" name="levzip">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Ort</mat-label>
                <input matInput [ngModel]="user.DeliveryCity" (ngModelChange)="user.DeliveryCity = $event" id="levcity" name="levcity" #levcity="ngModel">
              </mat-form-field>
            </div>                      
          </div>
        </mat-card>

        <mat-card class="card-margin input-card">
          <div class="row" style="margin-bottom: 15px;">
            <div class="col-12"><h4>Huvudsaklig arbetsgivare</h4></div>
            <div class="col-lg-12">
              <mat-checkbox matInput
                            [ngModel]="user?.SampoolenIsPrimaryEmployer"
                            (change)="changeSampoolenEmployerValue($event)"
                            id="employer"
                            name="employer">
                Sampoolen är huvudsaklig arbetsgivare
              </mat-checkbox>

              <br />
              <span style="font-weight: bold; margin-left: 10px;">Svarat:</span>
              <span *ngIf="user?.SampoolenIsPrimaryEmployerAnsweredDate">
                {{ user?.SampoolenIsPrimaryEmployerAnsweredDate | swedishDate: 'yyyy-MM-dd' }}
              </span>
              <span *ngIf="!user?.SampoolenIsPrimaryEmployerAnsweredDate">
                Har ej svarat
              </span>
              <br />
              <span *ngIf="user?.MunicipalityChangeDate">
                Skatt uppdateras: {{ user?.MunicipalityChangeDate | swedishDate: 'yyyy-MM-dd' }}  till {{pendingMunicipality}}
              </span>
            </div>
            <!--<div *ngIf="user.HasCoordinationNumber" class="col-sm-6">
        </div>
        <div *ngIf="user.HasCoordinationNumber" class="col-sm-6">
          <mat-form-field style="width: 100%" floatLabel="always">
            <mat-label>ÅÅÅÅMMDD</mat-label>
            <input matInput [ngModel]="user.BirthYear" (ngModelChange)="user.BirthYear = $event" ngModel pattern="[0-9]{8}" maxlength="8" id="BirthYear" name="BirthYear">
            <mat-hint>Födelsedatum (8 siffror)</mat-hint>
          </mat-form-field>
        </div>-->
          </div>
        </mat-card>

        <mat-card class="card-margin input-card">
          <div class="row" style="margin-bottom: 15px;">
            <!-- SALARY PAYOUT -->

            <div class="row" style="margin-bottom: 20px;">
              <div class="col-12">

                <div class="col-12" style="margin-top: 20px;">
                  <h4>Löneutbetalning</h4>
                </div>

                <div class="col-6">
                  <mat-form-field style="width: 100%" floatLabel="always">
                    <mat-label>Typ av utbetalning</mat-label>
                    <mat-select [ngModel]="user.PayoutType"
                                (ngModelChange)="onPayoutTypeChange($event)"
                                [ngModelOptions]="{standalone: true}">
                      <mat-option *ngFor="let s of payoutTypes" [value]="s.id">
                        {{ s.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>


                <div class="col-6">

                  <mat-form-field style="width: 100%" floatLabel="always" *ngIf="user.PayoutType == 2">
                    <mat-label>Dag i månaden</mat-label>
                    <input matInput required [ngModel]="user.PayoutDay"
                           (ngModelChange)="onPayoutDayChange($event)"
                           id="payoutday"
                           type="number"
                           min="1"
                           max="28"
                           name="payoutday">
                    <mat-error>
                      Ange en siffra mellan 1 och 28
                    </mat-error>
                    <mat-hint>
                      Ange en siffra mellan 1 och 28
                    </mat-hint>
                  </mat-form-field>
                </div>

                <div class="col-lg-12">
                  <span style="font-size: 80%">Välj om du vill ha lönen utbetald löpande när din kund betalar eller sammanställt en gång per månad.</span>
                </div>
              </div>
            </div>
            <!--/SALARY PAYOUT-->
          </div>
        </mat-card>

        <mat-card class="card-margin input-card">
          <div class="row" style="margin-bottom: 15px;">

            <div class="col-12" style="margin-top: 15px;">
              <h3>Koder</h3>
            </div>

            <div class="col-sm-12 col-md-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Personlig värvningskod</mat-label>
                <input matInput readonly aria-disabled="true" [ngModel]="user.ReferralCode" id="referral" name="referral">
              </mat-form-field>
            </div>

            <div class="col-sm-12 col-md-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Kampanjkod</mat-label>
                <input matInput [ngModel]="user.DiscountCode" (ngModelChange)="user.DiscountCode = $event" id="discountcode" name="discountcode">
              </mat-form-field>
            </div>

            <div class="col-sm-12 col-md-6" *ngIf="false && user.ReferredByUserId != null">
              <label>Värvad av</label>
              <div>
                <a [href]="'#/users/' + user.ReferredByUserId" target="_blank">{{ referredByName || user.ReferredByUserId }}</a>
              </div>
            </div>

            <div class="col-sm-12 col-md-6" *ngIf="false && user.ReferredByUserId == null">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Värvad av (ange värvningskod)</mat-label>
                <input matInput [ngModel]="ReferredCode" (ngModelChange)="ReferredCode = $event" id="referral2" name="referral2">
              </mat-form-field>
            </div>
          </div>
        </mat-card>
        <mat-card class="card-margin input-card">
          <div class="row" style="margin-bottom: 20px;">
            <div class="col-12">
              <h3>Avsättning till tjänstepension</h3>
            </div>

            <div class="col-lg-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Andel</mat-label>
                <input matInput
                       [ngModel]="user?.PensionSavingsSettings?.Amount"
                       (ngModelChange)="user.PensionSavingsSettings.Amount = $event"
                       type="number"
                       id="PensionAmount"
                       name="PensionAmount">
                <!--<input matInput required [ngModel]="user?.PensionSavingsSettings?.Amount" (ngModelChange)="user?.PensionSavingsSettings?.Amount = $event" placeholder="Procent eller kronor" id="PensionAmount" name="PensionAmount">-->
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field floatLabel="always" style="width: 100%;">
                <select [ngModel]="user?.PensionSavingsSettings?.Unit?.Id"
                        (ngModelChange)="pensionSavingsTypeChanged($event)"
                        matNativeControl
                        [ngModelOptions]="{standalone: true}">
                  <option value="1">Procent</option>
                  <option value="2">SEK</option>
                </select>
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <div>Val av tjänstepensionsföretag:</div>
              <mat-form-field floatLabel="always" style="width: 100%;">
                <select [ngModel]="user?.PensionSavingsSettings?.PensionSavingsCompany?.Id"
                        (ngModelChange)="pensionSavingsCompanyChanged($event)"
                        matNativeControl
                        [ngModelOptions]="{standalone: true}">
                  <option value="1">SPP</option>
                  <option value="2">Avanza</option>
                  <option value="3">Inget valt</option>
                </select>
              </mat-form-field>
            </div>
          </div>
        </mat-card>

        <mat-card class="card-margin input-card">
          <div class="row" style="margin-bottom: 15px;">
            <!-- BANK -->
            <div class="col-12">
              <h4>
                Bankinformation
              </h4>
            </div>
            <div class="col-12">

              <mat-form-field floatLabel="always" style="width: 100%;">
                <mat-label>Bank</mat-label>
                <mat-select [(ngModel)]="user.Bank.Id"
                            name="bank"
                            (ngModelChange)="bankOnChange($event)">
                  <mat-option *ngFor="let b of banks" [value]="b.Id">
                    {{ b.Name }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="!user?.Bank?.IsInternational">Bank härleds automatiskt från clearingnumret.</mat-hint>
              </mat-form-field>

            </div>
          </div>

          <div class="row" *ngIf="user.Bank.IsInternational" style="margin-bottom: 15px;">

            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>BIC</mat-label>
                <input matInput
                       [ngModel]="user.Bic"
                       (ngModelChange)="user.Bic = $event"
                       id="bic"
                       pattern="^(?:[a-zA-Z0-9]{8}|[a-zA-Z0-9]{11})$"
                       name="bic">
                <mat-error>Ange 8 eller 11 bokstäver och siffror</mat-error>
                <mat-hint>Ange 8 eller 11 bokstäver och siffror</mat-hint>
              </mat-form-field>
            </div>

            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>IBAN</mat-label>
                <input matInput
                       [ngModel]="user.Iban"
                       (ngModelChange)="user.Iban = $event"
                       id="iban"
                       pattern="[a-zA-Z0-9]{0,34}"
                       name="iban">
                <mat-error>Ange upp till 34 bokstäver och siffror</mat-error>
                <mat-hint>Ange upp till 34 bokstäver och siffror</mat-hint>
              </mat-form-field>
            </div>

          </div>

          <div class="row" *ngIf="user?.Bank?.Id == 0 || !user.Bank.IsInternational" style="margin-bottom: 15px;">

            <div class="col-sm-6" *ngIf="user?.Bank?.Id == 0 || user.Bank.ClearingRequired">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Clearingnummer</mat-label>
                <input matInput [ngModel]="user.ClearingNumber"
                       (ngModelChange)="onClearingNumberChange($event)"
                       id="ClearingNumber"
                       name="ClearingNumber">
                <mat-hint>Ange clearingnummer för svensk bank.</mat-hint>
              </mat-form-field>
            </div>

            <div class="col-sm-6" *ngIf="user?.Bank?.Id == 0 || user.Bank.Id > 0">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Kontonummer</mat-label>
                <input matInput [ngModel]="user.AccountNumber"
                       (ngModelChange)="onAccountNumberChange($event)"
                       id="AccountNumber"
                       name="AccountNumber">
                <mat-hint>Ange kontonummer. Numret valideras med checksiffra.</mat-hint>
              </mat-form-field>
            </div>


          </div>
        </mat-card>

        <mat-card class="card-margin input-card">
          <div class="row">
            <!-- Skattejämkningar -->

            <div class="col-6">
              <h3>Skattejämkning eller ändring av skatt</h3>
              <p class="section-description">Lägg till eller hantera skattejämkning/ändring av skatt för medlemmen.</p>
            </div>
            <div class="col-6">
              <!--Knapp för skattejämkning-->
              <button type="button" class="col-12" mat-stroked-button (click)="addTaxAdjustment($event)" style="margin-top:25px;float:right;"><mat-icon>add</mat-icon> &nbsp; Lägg till skattejämkning/ändra skatt &nbsp;</button>
            </div>
            <!--Visar tabell för skattejämkningar-->
            <div class="col-12">
              <mat-table #taxAdjustmentsTable [dataSource]="dataSourceTaxAdjustments" class="data-table tax-adjustments-table" style="margin-top: 15px;">

                <ng-container matColumnDef="type">
                  <mat-header-cell *matHeaderCellDef class="col-4">Typ</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="col-4">{{ row?.TaxAdjustmentType?.Name }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="startdate">
                  <mat-header-cell *matHeaderCellDef>Startdatum</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row?.DateStart | swedishDate: 'yyyy-MM-dd' }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="enddate">
                  <mat-header-cell *matHeaderCellDef>Slutdatum</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row?.DateEnd | swedishDate: 'yyyy-MM-dd' }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="maxamount">
                  <mat-header-cell *matHeaderCellDef>Maxsumma</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row?.MaxAmount | number : '1.2-2'  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="temptax">
                  <mat-header-cell *matHeaderCellDef>Tillfällig skatt</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row?.TemporaryTax * 100 | number : '1.2-2'  }} %</mat-cell>
                </ng-container>

                <ng-container matColumnDef="tempemptax">
                  <mat-header-cell *matHeaderCellDef>0 % AGA</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <span *ngIf="row?.ZeroEmployerTax">Ja</span>
                    <span *ngIf="!row?.ZeroEmployerTax"></span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="approved">
                  <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <span *ngIf="row?.DeniedByAdmin && !row?.ApprovedByAdmin">Ej godkänd</span>
                    <span *ngIf="!row?.DeniedByAdmin && row?.ApprovedByAdmin">Godkänd</span>
                    <span *ngIf="!row?.DeniedByAdmin && !row?.ApprovedByAdmin">Granskas</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="attachment">
                  <mat-header-cell *matHeaderCellDef>Fil</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <a *ngIf="row?.Attachment?.Guid != null" (click)="showFile(row.Attachment)"><mat-icon>open_in_new</mat-icon></a>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="admin">
                  <mat-header-cell *matHeaderCellDef style="border-left: 1px solid rgba(0, 0, 0, 0.12);">Admin</mat-header-cell>
                  <mat-cell *matCellDef="let row" style="border-left: 1px solid rgba(0, 0, 0, 0.12);">
                    <span class="table-admin-actions">
                      <a mat-icon-button (click)="deleteTaxAdjustment(row)" class="icon-delete"><mat-icon>delete_forever</mat-icon></a>
                      <a mat-icon-button (click)="editTaxAdjustment(row)"><mat-icon>edit</mat-icon></a>
                    </span>

                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumnsTaxAdjustments"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnsTaxAdjustments;">
                </mat-row>
              </mat-table>

              <div *ngIf="dataSourceTaxAdjustments.data.length === 0" class="table-empty-state">
                <mat-icon>folder_open</mat-icon>
                <span>Inga skattejämkningar eller ändringar har lagts till ännu.</span>
              </div>

            </div>
            <!-- Slut tabell för skattejämkning-->
            <!--<div class="col-sm-12">
          <button mat-stroked-button mat-flat-button color="warn" [disabled]="isLoading || !f.valid || !saveValidates()" style="float:right; margin-top:20px;">Spara</button>
        </div>-->
          </div>
        </mat-card>

        <mat-card class="card-margin input-card">
          <div class="row" style="margin-top: 20px;">
            <!-- Utmätning av lön -->

            <div class="col-6">
              <h3>Utmätning av lön</h3>
              <p class="section-description">Lägg till eller hantera utmätning av lön för medlemmen.</p>
            </div>
            <div class="col-6">
              <!--Knapp för att lägga till utmätning-->
              <button type="button" class="col-12" mat-stroked-button (click)="addAttachmentOfSalary($event)" style="margin-top:25px;float:right;"><mat-icon>add</mat-icon> &nbsp; Lägg till utmätning av lön &nbsp;</button>
            </div>

            <!--Visar tabell för utmätning -->
            <div class="col-12">

              <mat-table #attachmentsTable [dataSource]="dataSourceAttachmentOfSalary" class="data-table attachments-table" style="margin-top: 15px;">

                <ng-container matColumnDef="startdate">
                  <mat-header-cell *matHeaderCellDef>Startdatum</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row?.DateStart | swedishDate: 'yyyy-MM-dd' }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="enddate">
                  <mat-header-cell *matHeaderCellDef>Slutdatum</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row?.DateEnd | swedishDate: 'yyyy-MM-dd' }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="reservedamount">
                  <mat-header-cell *matHeaderCellDef>Reserverat belopp</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row?.ReservedAmount | number : '1.0-0'  }} SEK</mat-cell>
                </ng-container>

                <ng-container matColumnDef="attachmentamount">
                  <mat-header-cell *matHeaderCellDef>Utmätningsbelopp</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row?.AttachmentAmount | number : '1.0-0'  }} SEK</mat-cell>
                </ng-container>

                <ng-container matColumnDef="attachment">
                  <mat-header-cell *matHeaderCellDef>Fil</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <a *ngIf="row?.Document?.Guid != null" (click)="showFile(row.Document)"><mat-icon>open_in_new</mat-icon></a>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="admin">
                  <mat-header-cell *matHeaderCellDef style="border-left: 1px solid rgba(0, 0, 0, 0.12);">Admin</mat-header-cell>
                  <mat-cell *matCellDef="let row" style="border-left: 1px solid rgba(0, 0, 0, 0.12);">
                    <span class="table-admin-actions">
                      <a mat-icon-button (click)="deleteAttachmentOfSalary(row)" class="icon-delete"><mat-icon>delete_forever</mat-icon></a>
                      <a mat-icon-button (click)="editAttachmentOfSalary(row)"><mat-icon>edit</mat-icon></a>
                    </span>

                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumnsAttachmentsOfSalary"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnsAttachmentsOfSalary;">
                </mat-row>
              </mat-table>

              <div *ngIf="dataSourceAttachmentOfSalary.data.length === 0" class="table-empty-state">
                <mat-icon>folder_open</mat-icon>
                <span>Ingen utmätning av lön har lagts till ännu.</span>
              </div>

            </div>
            <!-- Slut tabell för utmätning -->


          </div>
        </mat-card>
      </form>

      <div class="row" style="margin-bottom:15px;">
        <div class="col-sm-12">
          <div *ngIf="!f.valid" style="color:red;">Ett eller fler obligatoriska fält saknar innehåll, eller bankinfo har fel antal siffror</div>
        </div>
      </div>
    </div>    
  </div>

  <!-- ********************* -->
  <!-- Company user settings -->
  <!-- ********************* -->

  <div *ngIf="user.IsCompany" class="row">
    <div class="col-12 entry">
      <br />
      <form name="form" *ngIf="!isLoading" (ngSubmit)="onSubmit()" #f="ngForm" novalidate>
        <mat-card class="card-margin input-card">
          <div class="row" style="margin-bottom: 15px;">
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Anställningsnummer</mat-label>
                <input matInput [ngModel]="user.EmploymentNumber" (ngModelChange)="user.EmploymentNumber = $event" id="employmentnumber" name="employmentnumber">
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Medlemsnummer</mat-label>
                <input matInput readonly [ngModel]="user.MemberNumber" (ngModelChange)="user.MemberNumber = $event" id="membernumber" name="membernumber">
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Företagets namn</mat-label>
                <input matInput [ngModel]="user.CompanyName" (ngModelChange)="user.CompanyName = $event" id="companyname" name="companyname">
              </mat-form-field>
            </div>
            <div class="col-lg-6" *ngIf="user.Country.Id == null || user.Country.Name == 'Sverige'">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Organisationsnr</mat-label>
                <input matInput [ngModel]="user.OrgNumber" (ngModelChange)="user.OrgNumber = $event" ngModel id="organisationsnr" name="Organisationsnr">
              </mat-form-field>
            </div>
            <div class="col-lg-6" *ngIf="user.Country.Id != null && user.Country.Name != 'Sverige'">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>VAT</mat-label>
                <input matInput [ngModel]="user.Vat" (ngModelChange)="user.Vat = $event" ngModel id="VAT" name="VAT">
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>E-post</mat-label>
                <input matInput [ngModel]="user.Email" (ngModelChange)="user.Email = $event" id="email" name="email">
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>E-post för proforma-faktura</mat-label>
                <input matInput [ngModel]="user.EmailInbox" (ngModelChange)="user.EmailInbox = $event" id="emailinbox" name="emailinbox">
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Telefon</mat-label>
                <input matInput [ngModel]="user.Phone" (ngModelChange)="user.Phone = $event" id="telephone" name="telephone">
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Land</mat-label>
                <mat-select name="country" id="country" [(ngModel)]="user.Country.Id" (ngModelChange)="user.Country.Id = $event; getCountryName(user.Country.Id);" [ngModelOptions]="{standalone: true}">
                  <mat-option *ngFor="let c of countries" [value]="c.Id">
                    {{ c.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Fakturadress -->
            <div class="col-lg-12" style="margin: 20px 0">
              <h4>Företagsadress</h4>
            </div>

            <div class="col-lg-12">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Företagsadress (gatuadress)</mat-label>
                <input matInput [ngModel]="user.Address" (ngModelChange)="user.Address = $event" id="address" name="address">
              </mat-form-field>
            </div>
            <div class="col-lg-12">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Företagsadress 2 (t ex c/o)</mat-label>
                <input matInput [ngModel]="user.Co" (ngModelChange)="user.Co = $event" id="coaddress" name="coaddress">
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Postnummer</mat-label>
                <input matInput [ngModel]="user.Zip" (ngModelChange)="user.Zip = $event" id="zip" name="zip">
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Ort</mat-label>
                <input matInput [ngModel]="user.City" (ngModelChange)="user.City = $event" id="city" name="city">
              </mat-form-field>
            </div>

            <!-- Leveransadress -->

            <div class="col-lg-12" style="margin: 20px 0">
              <h4>Särskild fakturaadress, om annan än ovan</h4>
            </div>

            <div class="col-lg-12">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Fakturaadress (gatuadress)</mat-label>
                <input matInput [ngModel]="user.DeliveryAddress" (ngModelChange)="user.DeliveryAddress = $event" id="levaddress" name="levaddress">
              </mat-form-field>
            </div>
            <div class="col-lg-12">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Fakturaadress 2 (t ex c/o)</mat-label>
                <input matInput [ngModel]="user.DeliveryCo" (ngModelChange)="user.DeliveryCo = $event" id="levaddress" name="levaddress2">
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Postnummer</mat-label>
                <input matInput [ngModel]="user.DeliveryZip" (ngModelChange)="user.DeliveryZip = $event" id="levzip" name="levzip">
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field style="width: 100%" floatLabel="always">
                <mat-label>Ort</mat-label>
                <input matInput [ngModel]="user.DeliveryCity" (ngModelChange)="user.DeliveryCity = $event" id="levcity" name="levcity" #levcity="ngModel">
              </mat-form-field>
            </div>



            <!-- Bankuppgifter -->
            <div class="col-lg-12" style="margin: 20px 0">
              <h4>Bankuppgifter</h4>
            </div>

            <div class="row col-lg-12" *ngIf="user.Country.Id == null || user.Country.Name == 'Sverige'">
              <div class="col-lg-6">
                <mat-form-field style="width: 100%" floatLabel="always">
                  <mat-label>Banknamn</mat-label>
                  <input matInput [ngModel]="user.BankName" id="BankName" name="BankName" readonly>
                </mat-form-field>
              </div>
              <div class="col-lg-3">
                <mat-form-field style="width: 100%" floatLabel="always">
                  <mat-label>Clearingnummer</mat-label>
                  <input matInput [ngModel]="user.ClearingNumber" (ngModelChange)="onClearingNumberChange($event)" id="ClearingNumber" name="ClearingNumber">
                </mat-form-field>
              </div>
              <div class="col-lg-3">
                <mat-form-field style="width: 100%" floatLabel="always">
                  <mat-label>Kontonummer</mat-label>
                  <input matInput [ngModel]="user.AccountNumber" (ngModelChange)="onAccountNumberChange($event)" id="AccountNumber" name="AccountNumber">
                </mat-form-field>
              </div>
              <div class="col-lg-6">
                <mat-form-field style="width: 100%" floatLabel="always">
                  <mat-label>Bankgiro</mat-label>
                  <input matInput [ngModel]="user.Bankgiro" (ngModelChange)="user.Bankgiro = $event" id="AccountNumber" name="Bankgiro">
                </mat-form-field>
              </div>

              <div class="col-lg-6">
                <mat-form-field style="width: 100%" floatLabel="always">
                  <mat-label>Plusgiro</mat-label>
                  <input matInput [ngModel]="user.Plusgiro" (ngModelChange)="user.Plusgiro = $event" id="AccountNumber" name="Plusgiro">
                </mat-form-field>
              </div>
            </div>

            <div class="row col-lg-12" *ngIf="user.Country.Id == null || user.Country.Name != 'Sverige'">
              <div class="col-lg-6">
                <mat-form-field style="width: 100%" floatLabel="always">
                  <mat-label>IBAN</mat-label>
                  <input matInput [ngModel]="user.Iban" (ngModelChange)="user.Iban = $event" id="iban" name="Iban">
                </mat-form-field>
              </div>

              <div class="col-lg-6">
                <mat-form-field style="width: 100%" floatLabel="always">
                  <mat-label>BIC</mat-label>
                  <input matInput [ngModel]="user.Bic" (ngModelChange)="user.Bic = $event" id="bic" name="Bic">
                </mat-form-field>
              </div>
            </div>

            <!-- Övrigt -->
            <div class="col-lg-12" style="margin: 20px 0">
              <h4>Övrigt</h4>
            </div>
            <div class="row col-12">
              <div class="col-lg-6">
                <div style="width: 100%" floatLabel="always">
                  <mat-checkbox matInput [ngModel]="user.FTax" (change)="changeFTaxValue($event)" id="ftax" name="ftax">Registrerad för F-skatt</mat-checkbox>
                </div>
              </div>
              <div class="col-lg-6">
                <mat-form-field style="width: 100%" floatLabel="always">
                  <mat-label>Provision, procent</mat-label>
                  <input type="number" matInput [ngModel]="Commission" (ngModelChange)="Commission = $event" id="commission" name="commission" #commission="ngModel">
                </mat-form-field>
              </div>
            </div>


          </div>
        </mat-card>
      </form>
    </div>
  </div>
<!-- ********************* -->
  <!-- Common settings -->
  <!-- ********************* -->

        </div>
      </div>
    </div>
    <footer *ngIf="!user?.IsCompany" class="user-edit-footer">
      <div class="validation-message" *ngIf="validationErrorMessage">{{validationErrorMessage}}</div>
      <span class="actions-spacer"></span>
      <button mat-stroked-button [disabled]="isLoading" (click)="dialogRef?.close()">Avbryt</button>
      <button mat-flat-button class="save-button" [disabled]="isLoading" color="accent" (click)="onSubmit()">Spara</button>
    </footer>
  </div>
</div>





